module.exports = __webpack_public_path__ + "img/commissions.e13d8e50.svg";